<a class="text-primary" [routerLink]="commands" [queryParams]="urlTree?.queryParams">
  <ng-content></ng-content>
</a>
